export default __webpack_public_path__ + "faf37cb7d223cabbc733c9641e3f2761.png";